window.whBundles||=[];window.whBundles["tollium:webinterface"]={dev:false};import "/opt/wh/whtree/modules/tollium/webdesigns/webinterface/webinterface";